import { authHeader } from '../helpers'
import { helper } from './serviceHelper'

export const globalService = {
	GetBankAll,
	SearchCustomer,
	getYaaUserProfileById,
	getIncentive,
	getIncentiveReportByProductMonthTrade,

	getOrganizationById,
	getIncentiveOrganization,
	getIncentiveOrganizationDetail,
	getIncentiveReportByProductMonthTradeOrganization,
	getIncentiveReportByProductMonthTradeOrganizationDetail,

	getSelectCommander,

	verifyCorporationCode,
	changePasswordUrl
}

function GetBankAll() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	// return fetch(`webapi/service/GetBankAll`, requestOptions).then(helper.handleResponse)
	return fetch(`api/services/GetBankAll`, requestOptions).then(helper.handleResponse)
}

function SearchCustomer(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/SearchCustomer`, requestOptions).then(helper.handleResponse)
}

function getYaaUserProfileById(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/services/GetYaaUserProfileById/${id}`, requestOptions).then(helper.handleResponse)
}

function getIncentive() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/users/GetIncentive`, requestOptions).then(helper.handleResponse)
}

function getIncentiveReportByProductMonthTrade(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/GetIncentiveReportByProductMonthTrade`, requestOptions).then(helper.handleResponse)
}

function getOrganizationById(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/users/GetOrganizationById/${id}`, requestOptions).then(helper.handleResponse)
}

function getIncentiveOrganization(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/users/GetIncentiveOrganization/${id}`, requestOptions).then(helper.handleResponse)
}

//GetIncentiveOrganizationDetail
function getIncentiveOrganizationDetail(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/users/GetIncentiveOrganizationDetail/${id}`, requestOptions).then(helper.handleResponse)
}

function getIncentiveReportByProductMonthTradeOrganization(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/GetIncentiveReportByProductMonthTradeOrganization`, requestOptions).then(
		helper.handleResponse
	)
}

//GetIncentiveReportByProductMonthTradeOrganizationDetail
function getIncentiveReportByProductMonthTradeOrganizationDetail(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/GetIncentiveReportByProductMonthTradeOrganizationDetail`, requestOptions).then(
		helper.handleResponse
	)
}

function getSelectCommander(data) {
	const requestOptions = {
		method: 'GET',
		headers: { ...authHeader(), 'Content-Type': 'application/json' },
	}

	return fetch(`api/users/GetSelectCommander`, requestOptions).then(helper.handleResponse)
}

function verifyCorporationCode(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/VerifyCorporationCode`, requestOptions).then(helper.handleResponse)
}

function changePasswordUrl(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/services/ChangePasswordUrl`, requestOptions).then(helper.handleResponse)
}
